import { render, staticRenderFns } from "./DocTemplate.vue?vue&type=template&id=46faef25&scoped=true"
import script from "./DocTemplate.vue?vue&type=script&lang=js"
export * from "./DocTemplate.vue?vue&type=script&lang=js"


/* normalize component */
import normalizer from "!../../../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "46faef25",
  null
  
)

export default component.exports